// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M0IXz","label":"styles_label__2hCFE"};